/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum PhType {
    KCl = "KCl",
    H2O = "H2O"
}

export default PhType;
